import { create } from 'zustand';
import type { AppState, CameraSettings, EncounterRecord } from '../../types';

const defaultSettings: CameraSettings = {
  facingMode: 'user',
  mirrorPreview: true,
  showFaceHud: true,
  guestName: 'Guest',
  colorSampling: 'full',
  showGpsHud: true,
  showPaletteHud: true,
  roi: { x: 0.24, y: 0.28, width: 0.52, height: 0.45 },
};

export interface NoticeAction {
  message: string;
  actionLabel: string;
  onAction: () => void;
}

interface AppStore {
  state: AppState;
  overlayReturnState: AppState | null;
  activeCaptureModuleId: string;
  settings: CameraSettings;
  currentEncounter: EncounterRecord | null;
  selectedEncounterId: string | null;
  notice: string | NoticeAction | null;
  navigate: (state: AppState) => void;
  openOverlay: (state: 'CAMERA_SETTINGS' | 'MODULE_SELECTOR', returnState?: AppState) => void;
  closeOverlay: () => void;
  updateSettings: (patch: Partial<CameraSettings>) => void;
  setEncounter: (record: EncounterRecord | null) => void;
  selectEncounter: (id: string | null) => void;
  setNotice: (notice: string | NoticeAction | null) => void;
}

export const useAppStore = create<AppStore>((set, get) => ({
  state: 'HOME',
  overlayReturnState: null,
  activeCaptureModuleId: 'gcam-default-v1',
  settings: defaultSettings,
  currentEncounter: null,
  selectedEncounterId: null,
  notice: null,
  navigate: (state) => set({ state, overlayReturnState: null }),
  openOverlay: (state, returnState) => set({ state, overlayReturnState: returnState ?? get().state }),
  closeOverlay: () => set((current) => ({ state: current.overlayReturnState ?? 'CAMERA_READY', overlayReturnState: null })),
  updateSettings: (patch) => set((current) => ({ settings: { ...current.settings, ...patch } })),
  setEncounter: (currentEncounter) => set({ currentEncounter }),
  selectEncounter: (selectedEncounterId) => set({ selectedEncounterId }),
  setNotice: (notice) => set({ notice }),
}));
